import { render, staticRenderFns } from "./FIcon.vue?vue&type=template&id=f773a112&"
import script from "./FIcon.vue?vue&type=script&lang=js&"
export * from "./FIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports